const _ = require('lodash');

const transformHashtagstIntoArray = (hashtagsString = '') => _.reject(_.map(_.split(hashtagsString, ','), tag => _.trim(tag)), _.isEmpty);

module.exports = {
  transformHashtagstIntoArray,
};



/** WEBPACK FOOTER **
 ** ./src/utils/hashtags-utils.js
 **/